// extracted by mini-css-extract-plugin
export default {"select":"SuperSelect_select__itiZx","option":"SuperSelect_option__V6Yan"};